// Domain 05 check helpers — read live (cloned) state; never mutate the lab.
import { clone } from '../../engine/net/model.js';
import { dhcpObtain, dnsQuery, hostIp, roundTrip } from '../../engine/net/sim.js';
import { fhrpState, ntpState, monitoringView, relayTarget } from '../../engine/net/services.js';
import { inSubnet, ipToInt } from '../../engine/net/addr.js';
import { MON, ZONE } from './topologies.js';
export * from '../d04/helpers.js';

/** The lease (or static config) a host holds right now. */
export const lease = (rt, id) => hostIp(rt.net.devices[id]);
/** What a NEW client on the user VLAN would be offered (tested on a copy). */
export function freshLease(rt, id = 'PC-01') {
  const n = clone(rt.net);
  const d = n.devices[id];
  d.lease = null; d.apipa = null;
  for (const r of Object.values(n.devices)) if (r.dhcp) r.dhcp.bindings = r.dhcp.bindings.filter((b) => b.mac !== d.nic.mac);
  const r = dhcpObtain(n, id);
  return r.ok ? r.lease : null;
}
const n32 = (ip) => ipToInt(ip) >>> 0;
/** A lease matching the Clark design: 10.50.10.50–.254/24, gw VIP .1, DNS .10, suffix, from R2. */
export function goodLease(l, { gw = '10.50.10.1', server = '10.50.20.1', domain = true } = {}) {
  return !!l && !l.apipa && inSubnet(l.ip, '10.50.10.0', '255.255.255.0') && l.mask === '255.255.255.0' && n32(l.ip) >= n32('10.50.10.50') && n32(l.ip) <= n32('10.50.10.254')
    && l.gw === gw && l.dns?.[0] === '10.50.20.10' && (!server || l.server === server) && (!domain || l.domain === ZONE);
}
export const relayOf = (rt, id, ifc = 'GigabitEthernet0/1') => relayTarget(clone(rt.net), id, ifc);
export const fhrp = (rt, id, proto = 'hsrp', group = 10, ifc = 'GigabitEthernet0/1') => fhrpState(clone(rt.net))[`${id}|${ifc}|${proto}|${group}`] || null;
export const ntp = (rt, id) => ntpState(clone(rt.net))[id] || { synced: false, stratum: 16 };
export const nms = (rt) => monitoringView(clone(rt.net), MON.ip, MON.community);
export const dns = (rt, src, name, server) => dnsQuery(clone(rt.net), src, name, server);
export const tcp = (rt, src, dst, port) => roundTrip(clone(rt.net), src, dst, { proto: 'tcp', port }).ok;
/** Works AND is clean (no alternating loss from duplicate gateways). */
export const tcpClean = (rt, src, dst, port) => { const r = roundTrip(clone(rt.net), src, dst, { proto: 'tcp', port }); return r.ok && !r.lossy; };
/** Windows `ipconfig /renew` that succeeded. */
export const renewed = (device) => (ev) => ev.type === 'cmd' && ev.device === device && ev.key === 'ipconfig /renew' && ev.result?.success;
export const winRan = (device, key, okOnly = true) => (ev) => ev.type === 'cmd' && ev.device === device && (Array.isArray(key) ? key.includes(ev.key) : ev.key === key) && (!okOnly || ev.ok !== false);
